import HoverText from "../hoverable-text/hoverable-text"
import Icon from "../icon/icon"
import PropTypes from "prop-types"
import Spinner from "../spinner/spinner"
import { TreeSelect } from "antd"

const { SHOW_PARENT } = TreeSelect
function TreeSelectInput(props) {
  const {
    label,
    placeholder,
    options,
    prefixIcon,
    getOptionLabel,
    showSearch,
    className,
    handleOnChange,
    inputLoading,
    getPopupContainer = true,
    treeNodeFilterProp = "",
    ...rest
  } = props

  const renderTreeSelect = () => {
    return (
      <>
        <TreeSelect
          showCheckedStrategy={SHOW_PARENT}
          treeData={options}
          onChange={handleOnChange}
          allowClear
          treeCheckable
          className={className}
          showSearch={showSearch}
          treeNodeFilterProp={treeNodeFilterProp}
          maxTagCount="responsive"
          filterTreeNode={(value, option) => {
            return getOptionLabel(option).toString().toLowerCase().startsWith(value.toLowerCase())
          }}
          maxTagPlaceholder={items => <HoverText message={`+${items.length}`} data={items.map(getOptionLabel)} />}
          showArrow
          suffixIcon={
            inputLoading ? (
              <Spinner type="plain" />
            ) : (
              <Icon icon="AiFillCaretDown" className="ant-select-suffix" color="#9D9D9D" size={"16px"} />
            )
          }
          placeholder={
            <>
              {prefixIcon && <Icon icon={prefixIcon} />}
              {placeholder && placeholder}
            </>
          }
          dropdownStyle={{ "--select-dropdown-accent-color": rest.accentColor }}
          {...(getPopupContainer ? { getPopupContainer: triggerNode => triggerNode.parentElement } : {})}
          {...rest}
        />
      </>
    )
  }
  const renderLabel = () => {
    return label && <label style={{ display: "block" }}>{label}</label>
  }
  return (
    <>
      <div>
        {renderLabel()}
        {renderTreeSelect()}
      </div>
    </>
  )
}

TreeSelectInput.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  getOptionLabel: PropTypes.func,
  prefixIcon: PropTypes.string,
  showSearch: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
}

TreeSelectInput.defaultProps = {
  options: [],
  getOptionLabel: item => item.label || item.name || item.title,
  showSearch: true,
}

export default TreeSelectInput
